export default __webpack_public_path__ + "0a31c9aca9ff1327a02328db42cebd03.png";